var slideArrow = '<svg class="icon icon-chevron-left" viewBox="0 0 8 18"><path d="M7.55.978A.705.705 0 007.413.01a.663.663 0 00-.945.142L.019 9.06l6.433 8.558a.664.664 0 00.947.127.704.704 0 00.121-.972L1.713 9.046z"></path></svg>'

// ie: Engine.ui.misc();
$(function() {
  "use strict";
  var Engine = {
    ui: {
      misc: function() {

        $(".theme-drawer-toggle,.cart-close,.cart-drawer-overlay").on('click', function() {
          $("body").toggleClass("CartOpen");
          return false;
        });

        $('.QuantityBox .plus').on('click', function() {            
          var $qty = $(this).parents('.QuantityBox').find(".QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (1 <= currentVal) {
            $(this).parents('.QuantityBox').find('li.minus-box').removeClass('disabled');
          }
          if (!isNaN(currentVal)) { $qty.val(currentVal + 1);}
        });
        $('.QuantityBox .minus').on('click', function() {
          var $qty = $(this).parents('.QuantityBox').find(".QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (currentVal <= 2) {
            $(this).parents('.QuantityBox').find('li.minus-box').addClass('disabled');
          }

          if (!isNaN(currentVal) && currentVal > 1) {$qty.val(currentVal - 1);}
        });


        $('ul.tabs li').on('click', function() {
          var tab_id = $(this).find("a[data-id]").attr('data-id');
          $('ul.tabs li').removeClass('active');
          $('.tab-content').removeClass('current');

          $(this).addClass('active');
          $("#" + tab_id).addClass('current');		

        })
        $('.menu-item>.menu-link-tigger').on('click', function() {
          if($(this).parent('li.menu-item').hasClass('in-active')){            
            $(this).parent('li.menu-item').removeClass('in-active');
            $(this).parent('li.menu-item').find('.submenu').slideUp('fast');
          }else{            
            $('li.menu-item').removeClass('in-active');
            $('li.menu-item').find('.submenu').slideUp('fast');
            $(this).parent('li.menu-item').addClass('in-active');
            $(this).parent('li.menu-item').find('.submenu').slideDown('fast');
          }          
        });
        $('.submenu .sub-menu-item>.menu-link-tigger').on('click', function() {
          if($(this).parent('li.sub-menu-item').hasClass('in-active')){            
            $(this).parent('li.sub-menu-item').removeClass('in-active');
            $(this).parent('li.sub-menu-item').find('.widget_nav').slideUp('fast');
          }else{            
            $('.submenu li.sub-menu-item').removeClass('in-active');
            $('.submenu li.sub-menu-item').find('.widget_nav').slideUp('fast');
            $(this).parent('li.sub-menu-item').addClass('in-active');
            $(this).parent('li.sub-menu-item').find('.widget_nav').slideDown('fast');
          }          
        });
        
        
        
     

        $('.navbar-expand-toggle').on('click', function() {
          if ( $(this).hasClass('active') ) {
            $(this).removeClass('active');
            $('body').removeClass('active-side-menu');  
          } else {
            $('.navbar-expand-toggle').removeClass('active');
            $(this).addClass('active');
            $('body').addClass('active-side-menu');  
          }
        });
        $('.mobile-nav-overlay').on('click', function() { 
          $('.navbar-expand-toggle').removeClass('active');
          $('body').removeClass('active-side-menu');  
        });

        if ($(window).width() < 768) {          
          $('.account_menu li a').on('click', function(e) {
            var slected_text = $(this).parents('.account_menu').find('.dropdown')
            var drop_text = $(this).text();
            slected_text.text(drop_text)
            $(this).parents('.tabs').slideUp('slow');
            slected_text.removeClass('collaped');
          })

          $('.account_menu .dropdown').on('click', function() {
            var sib = $(this).parent().find('.tabs');
            sib.slideToggle("slow");
            $(this).toggleClass('collaped')
          });


        }

        if ($(window).width() < 576) {          
          $('.theme_filter_bar .dropdown').on('click', function(e) {
            var slected_text = $(this).parents('.theme_filter_bar').find('.dropdown')
            var drop_text = $(this).text();
            slected_text.text(drop_text)
            $(this).parents('.tabs').slideUp('slow');
            slected_text.removeClass('collaped');
          })

          $('.theme_filter_bar .dropdown').on('click', function() {
            var sib = $(this).parent().find('.filter_items');
            sib.slideToggle("slow");
            $(this).toggleClass('collaped')
          });


        }



      }, // end misc     
    }, // end ui
    utils: {
      sliders: function() {    



        $('.product-feature-slider').slick({
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,     
          touchThreshold: 1,
          infinite: true,
          slide: 'li',
          centerMode: false,          
          prevArrow: '<button type="button" class="slick-prev">'+slideArrow+'</button>',
          nextArrow: '<button type="button" class="slick-next">'+slideArrow+'</button>',
          draggable: true,      
          speed: 1000,      
          autoplaySpeed: 2000,          
          useTransform: true,                 
          cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',      
          focusOnSelect: false,
          responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 567,
              settings: {
                slidesToShow: 1,
                arrows: false,
                centerMode: true,
                swipeToSlide:true,
                touchThreshold:7,
                centerPadding: '40px'
              }
            }
          ]
        });  
        $('ul.slideshow-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          infinite: true,
          prevArrow: '<button type="button" class="slick-prev">'+slideArrow+'</button>',
          nextArrow: '<button type="button" class="slick-next">'+slideArrow+'</button>',
          fade: false,
           autoplay:true,
          speed: 1000
        });



      },
    }, // end utils
  };
  Engine.ui.misc();
  Engine.utils.sliders();
});




$(document).on('click', '.product-tabs-wrapper .nav-link', function(){      
  $('.product-feature-slider').slick('slickUnfilter');
  $('.product-feature-slider').slick('slickFilter','.all').slick('refresh');
});

function stickyHeader(){  
  var headerContentHeight = $('.theme-header').innerHeight();
  $('.mobile_sidemenu,.mobile-nav-overlay').css('top', headerContentHeight + 'px');
}

$(document).ready(function(){
  setTimeout(function() {    
    stickyHeader();
  }, 1000);
});
$(window).resize(function(){  
  stickyHeader();
});

$(document).ready(function(){
  $(".wc_review_badge_inner").click(function(){
    $("#contact-tab").trigger("click");
  });

//   $('ul.fillter_nav_list li.fn_item a').click(function() {
//     $(this).siblings('.nav_sublist').slideToggle('slow');
//   });  

});


$('.search-bar__form').submit(function(e){e.preventDefault();  var val = $(this).find('input').val(); window.location.href = "https://intl.petsafe.net/en-gb/search?q="+val; })
$(document).on('change', 'select.cart__qty-input', function() {
  $(this).parents('.cart__row').find('.cart__qty-input').val($(this).val());
  $(this).parents('.cart__row').find('[data-max]').trigger('change');

});

$(document).ready(function(){ // on document ready
  $(".nav .nav-item:first-child a").click(); // click the element
  $('.product-grid-title').matchHeight({property: 'height'});
})

$(document).on('click','.modal-backdrop',function(){
  $('.modal-header .close').trigger('click');   
})

  